import update from 'immutability-helper';
import { REHYDRATE } from 'redux-persist/constants';
import hasPath from 'ramda/src/hasPath';
import ActionTypes from 'constants/ActionTypes';
import { KEYWORD_COLUMNS } from 'constants/keywordColumns';

const initialState = {
    isDropdownVisible: false,
    evManuallyEnabledInDomainMode: false, // Track if user manually enabled EV in domain mode
    visible: {
        [KEYWORD_COLUMNS.SERP_FEATURES]: true,
        [KEYWORD_COLUMNS.CONTENT_TYPE]: true,
        [KEYWORD_COLUMNS.SEARCH_INTENT]: true,
        [KEYWORD_COLUMNS.KW_OPPORTUNITIES]: true,
        [KEYWORD_COLUMNS.AVG_SEARCH_VOLUME]: true,
        [KEYWORD_COLUMNS.TREND]: true,
        [KEYWORD_COLUMNS.EV]: true,
        [KEYWORD_COLUMNS.POS]: true,
        [KEYWORD_COLUMNS.CPC]: true,
        [KEYWORD_COLUMNS.PPC]: true,
        [KEYWORD_COLUMNS.KEYWORD_DIFFICULTY]: true,
    }
};

const KEYWORD_COLUMNS_ARRAY = Object.keys(KEYWORD_COLUMNS)

const keywordsColumnsSettingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.UI_KEYWORD_COLUMNS_SETTINGS_CHANGE: {
            if (!KEYWORD_COLUMNS_ARRAY.includes(action.payload.column)) {
                // just prevent from incorrect usage
                return state
            }
            
            // Track if user manually enables EV column in domain mode
            const isEvColumnToggle = action.payload.column === KEYWORD_COLUMNS.EV;
            const isEnablingEv = action.payload.value === true;
            const shouldTrackManualEnable = isEvColumnToggle && isEnablingEv && action.payload.isDomainMode;
            
            return update(state, {
                visible: {
                    [action.payload.column]: {
                        $set: action.payload.value,
                    }
                },
                ...(shouldTrackManualEnable && {
                    evManuallyEnabledInDomainMode: {
                        $set: true,
                    }
                })
            });
        }
        case ActionTypes.UI_KEYWORD_COLUMNS_SETTINGS_DROPDOWN_VISIBLE: {
            return update(state, {
                isDropdownVisible: {
                    $set: action.payload,
                },
            });
        }
        case REHYDRATE: {
            let newVisible = initialState.visible
            let newEvManuallyEnabled = initialState.evManuallyEnabledInDomainMode
            
            if (hasPath(['ui', 'columnsSettings', 'keywords'], action.payload)) {
                const savedState = action.payload.ui.columnsSettings.keywords
                newVisible = savedState.visible
                newEvManuallyEnabled = savedState.evManuallyEnabledInDomainMode || false
                
                // Set default values for new columns
                if (newVisible[KEYWORD_COLUMNS.KW_OPPORTUNITIES] === undefined) {
                    newVisible[KEYWORD_COLUMNS.KW_OPPORTUNITIES] = true
                }
                if (newVisible[KEYWORD_COLUMNS.SERP_FEATURES] === undefined) {
                    newVisible[KEYWORD_COLUMNS.SERP_FEATURES] = true
                }
            }
            
            return update(state, {
                visible: {
                    $set: newVisible,
                },
                evManuallyEnabledInDomainMode: {
                    $set: newEvManuallyEnabled,
                }
            });
        }
        default: {
            return state;
        }
    }
};

export default keywordsColumnsSettingsReducer;
